import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  position: relative;
  height: 42px;
  min-width: 42px;
  width: 42px;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    background-color: var(--solution-secondary-color);
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    border: 1px solid var(--solution-primary-color);
    opacity: 0.2;
  }

  svg {
    position: relative;
  }
`;
